const getFormattedRelativeTime = (date) => {
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 60000);
    const formatter = new Intl.RelativeTimeFormat('en-US', { numeric: 'auto', style: 'short' });
    const format = (value, unit) => {
        return formatter.format(value, unit).replace('.', '');
    };
    if (minutes < 60) {
        return format(-minutes, 'minute');
    }
    if (minutes < 1440) {
        const hours = Math.floor(minutes / 60);
        return format(-hours, 'hour');
    }
    const days = Math.floor(minutes / 1440);
    return format(-days, 'day');
};
const formatDate = (date) => {
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
};

export { formatDate, getFormattedRelativeTime };
//# sourceMappingURL=date.mjs.map
